(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function activateTab(tabNumber) {
    // Remove active class from all buttons
    document.querySelectorAll('.tabs button').forEach(button => {
      button.classList.remove('active');
    });

    // Add active class to the clicked button
    const activeButton = document.querySelector(`.tabs button[data-tab="${tabNumber}"]`);
    activeButton.classList.add('active');

    // Hide all overlay texts immediately
    document.querySelectorAll('.overlay-text').forEach(box => {
      box.classList.remove('active');
    });

    // Use setTimeout to add a delay before showing the selected overlay text
    setTimeout(() => {
      const selectedBox = document.getElementById(`overlay-text-${tabNumber}`);
      selectedBox.classList.add('active');
    }, 1000); // 1000ms delay

    // Manage visibility of content blocks
    const contentBlocks = document.querySelectorAll('.content');
    contentBlocks.forEach((block, index) => {
      if (index === tabNumber - 1) {
        block.classList.add('visible'); // Show current block
      } else {
        block.classList.remove('visible'); // Hide others
      }
    });

    // Scroll to the relevant content section vertically
    const contentContainer = document.querySelector('.content-container');
    const contentHeight = contentContainer.querySelector('.content').offsetHeight;
    contentContainer.scrollTo({
      top: contentHeight * (tabNumber - 1),
      behavior: 'smooth'
    });
  }

  // Add click event listeners to the tabs
  document.querySelectorAll('.tabs button').forEach((button, index) => {
    button.addEventListener('click', () => activateTab(index + 1));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hills-editorial"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-hs-editorial-grid]').forEach(function(grid) {
    var limit = parseInt(grid.getAttribute('data-items-to-show'), 10) || 6;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.hs-editorial-card'));
    var seen = {};
    cards.forEach(function(card) {
      var handle = card.dataset.handle || '';
      if (handle && seen[handle] && !card.dataset.featured) card.remove();
      else if (handle) seen[handle] = true;
    });
    cards = Array.prototype.slice.call(grid.querySelectorAll('.hs-editorial-card'));
    cards.sort(function(a, b) {
      var exposureDelta = parseInt(b.dataset.exposure || '0', 10) - parseInt(a.dataset.exposure || '0', 10);
      if (exposureDelta !== 0) return exposureDelta;
      return parseInt(a.dataset.articleIndex || '0', 10) - parseInt(b.dataset.articleIndex || '0', 10);
    });
    cards.forEach(function(card, index) {
      grid.appendChild(card);
      card.hidden = index >= limit;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hills-home-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-hs-hero-carousel]').forEach(function(carousel) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-hs-hero-slide]'));
    var dots = carousel.querySelector('[data-hs-hero-dots]');
    var prev = carousel.querySelector('[data-hs-hero-prev]');
    var next = carousel.querySelector('[data-hs-hero-next]');
    if (slides.length < 2) {
      var controls = carousel.querySelector('.hs-hero__carousel-controls');
      if (controls) controls.hidden = true;
      return;
    }
    var current = 0;
    var timer;
    slides.forEach(function(slide, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'hs-hero__dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Show image ' + (index + 1));
      dot.addEventListener('click', function() { show(index); restart(); });
      dots.appendChild(dot);
    });
    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function(slide, i) { slide.classList.toggle('is-active', i === current); });
      Array.prototype.slice.call(dots.children).forEach(function(dot, i) { dot.classList.toggle('is-active', i === current); });
    }
    function restart() { window.clearInterval(timer); timer = window.setInterval(function() { show(current + 1); }, 3000); }
    if (prev) prev.addEventListener('click', function() { show(current - 1); restart(); });
    if (next) next.addEventListener('click', function() { show(current + 1); restart(); });
    carousel.addEventListener('mouseenter', function() { window.clearInterval(timer); });
    carousel.addEventListener('mouseleave', restart);
    carousel.addEventListener('focusin', function() { window.clearInterval(timer); });
    carousel.addEventListener('focusout', restart);
    restart();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hills-short-stays"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSearch(form) {
    var checkin = form.querySelector('[name="checkin"]');
    var checkout = form.querySelector('[name="checkout"]');
    var today = new Intl.DateTimeFormat('en-CA', {timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit'}).format(new Date());
    if (checkin) checkin.min = today;
    if (checkout) checkout.min = today;
    if (checkin && checkout) checkin.addEventListener('change', function() { checkout.min = checkin.value || today; });
    form.addEventListener('submit', function(event) {
      event.preventDefault();
      var guests = form.querySelector('[name="guests"]');
      var toast = document.querySelector('[data-hs-search-toast]');
      function showToast(message) {
        if (!toast) return;
        toast.textContent = message;
        toast.hidden = false;
        window.clearTimeout(toast._hideTimer);
        toast._hideTimer = window.setTimeout(function() { toast.hidden = true; }, 4200);
      }
      if (!checkin.value || !checkout.value || !guests || !guests.value) {
        showToast('Please choose your check-in date, check-out date and number of guests first.');
        return;
      }
      if (checkout.value <= checkin.value) {
        showToast('Please choose a check-out date after your check-in date.');
        return;
      }
      var raw = form.getAttribute('data-search-url') || '/pages/stay-search-results';
      if (raw.indexOf('shopify://collections/') === 0 || raw.indexOf('shopify://pages/') === 0) raw = raw.replace('shopify://', '/');
      var destination = new URL(raw, window.location.origin);
      destination.searchParams.set('checkin', checkin.value);
      destination.searchParams.set('checkout', checkout.value);
      destination.searchParams.set('guests', guests.value);
      window.location.assign(destination.toString());
    });
  }

  function loadLeaflet(done, fail) {
    if (window.L) { done(); return; }
    var existing = document.querySelector('script[data-hs-leaflet]');
    if (existing) {
      existing.addEventListener('load', done, { once: true });
      existing.addEventListener('error', fail, { once: true });
      return;
    }
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(css);
    var script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.async = true;
    script.dataset.hsLeaflet = 'true';
    script.onload = done;
    script.onerror = fail;
    document.head.appendChild(script);
  }

  function escapeHtml(value) {
    var helper = document.createElement('div');
    helper.textContent = value || '';
    return helper.innerHTML;
  }

  function renderStaticPins(mapElement) {
    var layer = mapElement.querySelector('.hs-static-pin-layer');
    if (!layer) return;
    var cards = Array.prototype.slice.call(mapElement.parentElement.querySelectorAll('.hs-stay-card'));
    var minLat = 30.95;
    var maxLat = 31.55;
    var minLng = 121.1;
    var maxLng = 121.95;
    cards.forEach(function(card) {
      card.addEventListener('mouseenter', function() { setActiveCard(card, false); });
      card.addEventListener('focusin', function() { setActiveCard(card, false); });
    });
    cards.forEach(function(card, index) {
      var lat = parseFloat(card.dataset.lat);
      var lng = parseFloat(card.dataset.lng);
      if (isNaN(lat) || isNaN(lng)) return;
      var pin = document.createElement('a');
      pin.className = 'hs-static-pin';
      pin.href = card.dataset.url;
      pin.title = card.dataset.title || 'Shanghai stay';
      pin.setAttribute('aria-label', card.dataset.title || 'Shanghai stay');
      pin.style.left = Math.max(3, Math.min(97, ((lng - minLng) / (maxLng - minLng)) * 100)) + '%';
      pin.style.top = Math.max(5, Math.min(95, (1 - ((lat - minLat) / (maxLat - minLat))) * 100)) + '%';
      pin.dataset.stayIndex = index;
      pin.addEventListener('mouseenter', function() { setActiveCard(cards[index], true); });
      pin.addEventListener('focus', function() { setActiveCard(cards[index], true); });
      layer.appendChild(pin);
    });
  }

  function setActiveCard(card, shouldScroll) {
    if (!card) return;
    var list = card.parentElement;
    Array.prototype.slice.call(list.querySelectorAll('.hs-stay-card')).forEach(function(item) {
      item.classList.toggle('is-active', item === card);
    });
    if (shouldScroll && window.matchMedia('(min-width: 750px)').matches) {
      list.scrollTo({ left: Math.max(0, card.offsetLeft - (list.clientWidth - card.offsetWidth) / 2), behavior: 'smooth' });
    }
  }

  function initMap(mapElement) {
    if (!window.L || mapElement.dataset.ready === 'true') return;
    var cards = Array.prototype.slice.call(mapElement.parentElement.querySelectorAll('.hs-stay-card'));
    var fallback = mapElement.querySelector('.hs-shanghai-map__fallback');
    var staticPins = mapElement.querySelector('.hs-static-pin-layer');
    if (fallback) fallback.style.display = 'none';
    if (staticPins) staticPins.remove();
    var map = window.L.map(mapElement, { scrollWheelZoom: false, zoomControl: true }).setView([31.2304, 121.4737], 10);
    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '© OpenStreetMap contributors'
    }).addTo(map);
    var bounds = [];
    cards.forEach(function(card, index) {
      var lat = parseFloat(card.dataset.lat);
      var lng = parseFloat(card.dataset.lng);
      if (isNaN(lat) || isNaN(lng)) return;
      bounds.push([lat, lng]);
      var icon = window.L.divIcon({ className: 'hs-leaflet-pin', html: '', iconSize: [32, 32], iconAnchor: [16, 16] });
      var marker = window.L.marker([lat, lng], { icon: icon }).addTo(map);
      marker.bindPopup('<strong>' + escapeHtml(card.dataset.title) + '</strong><br><span>From ' + escapeHtml(card.dataset.price) + ' / night</span><br><a href="' + encodeURI(card.dataset.url) + '">View stay →</a>');
      function activateMarker() {
        setActiveCard(card, true);
        marker.setZIndexOffset(1000);
        marker.openPopup();
      }
      function resetMarker() { marker.setZIndexOffset(0); }
      marker.on('mouseover', activateMarker);
      marker.on('focus', activateMarker);
      marker.on('click', activateMarker);
      marker.on('mouseout', resetMarker);
      card.addEventListener('mouseenter', activateMarker);
      card.addEventListener('focusin', activateMarker);
      card.addEventListener('mouseleave', resetMarker);
    });
    function fitStayBounds() {
      if (bounds.length < 2) return;
      map.fitBounds(bounds, { padding: [24, 24], maxZoom: 12 });
      var fittedZoom = map.getZoom();
      if (typeof fittedZoom === 'number') map.setZoom(Math.min(12, fittedZoom + 1));
    }
    fitStayBounds();
    mapElement.dataset.ready = 'true';
    var loading = mapElement.querySelector('.hs-map-loading');
    if (loading) loading.remove();

    // The map can initialize while the Shopify preview is still laying out the
    // two-column grid. Recalculate after layout so the tile pane gets a real
    // height instead of collapsing to 0px behind the markers.
    function refreshMapSize() {
      map.invalidateSize({ pan: false, debounceMoveend: true });
      fitStayBounds();
    }
    window.requestAnimationFrame(refreshMapSize);
    window.setTimeout(refreshMapSize, 120);
    window.setTimeout(refreshMapSize, 600);
    if (window.ResizeObserver) {
      var resizeObserver = new window.ResizeObserver(refreshMapSize);
      resizeObserver.observe(mapElement);
    }
  }

  document.querySelectorAll('[data-hs-stay-search]').forEach(initSearch);
  document.querySelectorAll('[data-hs-real-map]').forEach(function(mapElement) {
    renderStaticPins(mapElement);
    loadLeaflet(function() { initMap(mapElement); }, function() {
      var loading = mapElement.querySelector('.hs-map-loading');
      if (loading) loading.textContent = 'Browse the live Shanghai map and select a stay.';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hills-stay-search-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-hs-stay-results]');
  if (!root) return;
  var params = new URLSearchParams(window.location.search);
  var checkin = params.get('checkin') || '';
  var checkout = params.get('checkout') || '';
  var guests = params.get('guests') || '';
  var feedback = root.querySelector('[data-hs-results-feedback]');
  var grid = root.querySelector('[data-hs-results-grid]');
  var template = root.querySelector('[data-hs-result-template]');
  var summary = root.querySelector('[data-hs-results-summary]');
  function message(text, failed) {
    feedback.textContent = text;
    feedback.classList.toggle('is-error', failed);
  }
  function validDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    var day = new Date(value + 'T00:00:00Z');
    return Number.isFinite(day.getTime()) && day.toISOString().slice(0, 10) === value;
  }
  if (!validDate(checkin) || !validDate(checkout) || checkout <= checkin || !/^[1-9]\d*$/.test(guests)) {
    summary.textContent = 'Choose dates and guests to see live availability.';
    message('Please choose valid check-in and check-out dates and the exact number of guests.', true);
    return;
  }
  summary.textContent = 'For ' + checkin + ' to ' + checkout + ' · ' + guests + ' guest(s)';
  var endpoint;
  try {
    endpoint = new URL(root.getAttribute('data-endpoint'), window.location.origin);
    if (endpoint.origin !== window.location.origin || !endpoint.pathname.startsWith('/apps/')) throw new Error('Invalid endpoint');
  } catch (_) {
    message('Availability service is not configured yet. Please contact Hills Shanghai.', true);
    return;
  }
  ['checkin', 'checkout', 'guests'].forEach(function (key) { endpoint.searchParams.set(key, params.get(key)); });
  var controller = new AbortController();
  var timer = setTimeout(function () { controller.abort(); }, 30000);
  message('Checking live availability…', false);
  root.setAttribute('aria-busy', 'true');
  fetch(endpoint.toString(), {headers: {Accept: 'application/json'}, signal: controller.signal})
    .then(function (response) {
      if (!response.ok) throw new Error('Availability request failed');
      return response.json();
    })
    .then(function (payload) {
      if (!payload || !Array.isArray(payload.results)) throw new Error('Invalid results');
      var seen = new Set();
      var fragment = document.createDocumentFragment();
      var count = 0;
      payload.results.forEach(function (record) {
        if (!record || typeof record.handle !== 'string' || !/^[a-z0-9][a-z0-9-]*$/.test(record.handle) || typeof record.available !== 'boolean' || seen.has(record.handle)) throw new Error('Invalid record');
        seen.add(record.handle);
        var card = template.content.firstElementChild.cloneNode(true);
        card.dataset.handle = record.handle;
        card.classList.add(record.available ? 'is-available' : 'is-unavailable');
        if (record.available) count += 1;
        var link = new URL('/products/' + encodeURIComponent(record.handle), window.location.origin);
        ['checkin', 'checkout', 'guests'].forEach(function (key) { link.searchParams.set(key, params.get(key)); });
        card.querySelectorAll('a').forEach(function (a) { a.href = link.toString(); });
        card.querySelector('[data-hs-title]').textContent = typeof record.title === 'string' && record.title ? record.title : record.handle;
        card.querySelector('[data-hs-result-status]').textContent = record.available ? 'Available for your dates' : (typeof record.reason === 'string' && record.reason ? record.reason : 'Availability could not be confirmed');
        if (typeof record.imageUrl === 'string') {
          try {
            var imageUrl = new URL(record.imageUrl);
            if (imageUrl.protocol === 'https:' && imageUrl.hostname === 'cdn.shopify.com') {
              var img = document.createElement('img');
              img.className = 'hs-result-card__image'; img.loading = 'lazy'; img.alt = typeof record.title === 'string' ? record.title : '';
              img.src = imageUrl.toString();
              card.querySelector('.hs-result-card__media').replaceChildren(img);
            }
          } catch (_) { /* Keep the placeholder. */ }
        }
        // The current product-page booking flow selects its own rate plan.
        // Avoid presenting a different search rate as a checkout quote.
        fragment.appendChild(card);
      });
      grid.replaceChildren(fragment);
      message(payload.results.length ? count + ' available stays · ' + payload.results.length + ' stays checked.' : 'No short stays are listed for this search yet.', false);
    })
    .catch(function () {
      grid.replaceChildren();
      message('Availability service is currently unavailable. Please contact Hills Shanghai to confirm your stay.', true);
    })
    .finally(function () { clearTimeout(timer); root.setAttribute('aria-busy', 'false'); });
})();

  } catch(e) { console.error(e); }
})();
})();
